export enum CohortTrackEvents {
  COHORT_CHANGE_INITIATED = 'COHORT_CHANGE_INITIATED',
  COHORT_CHANGE_CONFIRMED = 'COHORT_CHANGE_CONFIRMED',
  COHORT_CHANGE_SUCCESS = 'COHORT_CHANGE_SUCCESS',
}



// WEBPACK FOOTER //
// ./ts/app/shared/types/cohort-track-events.enum.ts